<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
        <!-- LIST -->
        <el-col :span="24">
          <el-card class="box-card">
            <loginas v-model="loggedInChanged" v-if="auth.name=='tefl'" />
            <!-- <import v-if="auth.name=='tefl' && !isLoggedInAs"></import> -->

            <new></new>
            <div class="card-header">
              <h4 class="card-title">Existing customers</h4>
              <p
                class="category"
              >List of existing customers, you can use the search form above to search for a specific customer.</p>
              <br />
               <router-link class="el-button" v-if="property" :to="'/customer/list/'">View all customers</router-link>
       
            </div>
            <div v-if="error">{{error}}</div>
         
            <div class="table-responsive">
              <ApolloQuery
              deep
              ref="queryComponentRef"
                :query="property?searchquery():require('./customerList.gql')"
                fetchPolicy="no-cache"
              >
                <template slot-scope="{ result: { data, loading } }">
                  <div v-if="loading">Loading...</div>
                  <data-tables-server
                    v-else-if="data"
                    class="table-shopping"
                    style="width: 100%"
                    :data="data.Customer"
                    :tool-bar="false"
                    :current-page="1"
                    :total="data.Customer.length"
                    :loading="loading"
                    :page-size="20"
                    :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
                  >
                    
                       <el-table-column label="Name" min-width="40" >
                         <template slot-scope="props">
                         {{props.row.firstname}} {{props.row.lastname}}
                         </template>
                       </el-table-column>
                
                       <el-table-column label="Email" min-width="60" >
                                <template slot-scope="props">
                         {{props.row.email}}
                         </template>
                       </el-table-column>
                    <el-table-column label="Enrollments" min-width="180">
                      <template slot-scope="props">
                        <el-col :span="24"
                          v-for="enrollment in props.row.enrollments"
                          v-bind:key="enrollment.id"
                        >
                         <el-col :span="10"> {{enrollment.product.name}}</el-col>
                         
                         <el-col :span="10"> Expires: {{enrollment.expiry_date}}</el-col>
                        <el-col :span="10"> <el-tag :type="enrollment.online_course_passed?'success':'danger'"> <span v-if="enrollment.online_course_passed">Passed | {{enrollment.passed_date | moment('YYYY-MM-DD hh:mm:ss')}}</span> <span v-else>In Progress</span></el-tag></el-col>
                        </el-col>
                      </template>
                    </el-table-column>
                       <el-table-column label="View Progress" width="120"  type="expand">
                      
                      <template slot-scope="props"> 
                        <lmsprogress :customer="props.row" ></lmsprogress>
                        </template>
                         </el-table-column>
                    <el-table-column label="Edit" min-width="40">
                      <template slot-scope="props">
                        <router-link :to="'/customer/edit/'+props.row.id">Edit</router-link>
                      </template>
                    </el-table-column>
                      <el-table-column label="Partner" min-width="40" v-if="auth.name=='tefl' && !isLoggedInAs">
                      <template slot-scope="props">
                       {{ props.row.partner.name}}
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <div v-else class="no-result apollo">No result :(</div>
                </template>
              </ApolloQuery>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>

import gql from "graphql-tag";
import Lmsprogress from './CustomerProfile/LMSProgress.vue'
import Import from './Import.vue'
import New from './New.vue'
import Loginas from './Loginas.vue'
export default {
  components: {
      Lmsprogress,
     Import,
     New,
     Loginas
  },
  props: ["property", "value","email"],

  data() {
    return {
      hasquery: false,
      loading:false,
      queryValue: "",
      loadingCustomers: false,
      customerTitles: ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof", "Rev"],
      results: [],
      customer: {},
      searchQuery: "",
loggedInChanged:false,
      dialogVisible: false,
      error: null,
      total: 0
    };
  },

  methods: {

 

    toggleDialog(id) {
      this.dialogVisible = !this.dialogVisible;
    },

    searchquery() {
      return gql`
        query myQuery{ 
  Customer(where: {${this.property}: {_ilike: "%${this.value}%"}}) {
    firstname
    lastname
    username
    email
    id
    enrollments {
      created_at
      product {
        name
        hours
      }
      expiry_date
      online_course_passed
      passed_date
    }
    partner{
      name
    }
  }
        }

        `;
    }
  },
  watch: {
    "$route.params.value": function(value) {
      console.log(value);
      if (value) {
        this.hasquery = true;
        this.searchquery();
      }
      // this.loadData();
    },
     loggedInChanged(newValue, oldValue)
    {
      console.log('oldValue',newValue)
      if (newValue !== oldValue) 
     this.$refs.queryComponentRef.getApolloQuery().refetch();
    }
  },
  mounted() {
    //  this.loadData();
  },
  computed:{
    auth(){
       const profile = this.$store.getters.getProfile
        return profile
        
    },
     isLoggedInAs(){
       const loggedInAs = this.$store.getters.loggedInAs
        return loggedInAs
        
    }
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Customers/Search.vue